import { render, staticRenderFns } from "./onebox-redirectdirectory.vue?vue&type=template&id=79e2bdcc&"
import script from "./onebox-redirectdirectory.vue?vue&type=script&lang=js&"
export * from "./onebox-redirectdirectory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports